import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getKeyActivities';

export const getKeyActivities = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
